define(function(require){
	'use strict';

	var I18n       = require('i18n!nls/main');
	var Marionette = require('marionette');
	var AppConfig = require('config/application');

	return Backbone.Model.extend({
		/*
		*	function defaults()
		*	Get model defaul values
		*	@return {json}	defaults
		*/
		defaults: function(){
			return {
				deleteable 		: 1,
				site_id 		: app.curProject.id,
				list 			: 'crater',
				order 			: 0,
				editable		: 1,
				movable 		: 1,
				name			: I18n.cr.new_step_name,
				style 			: 'DDDDDD',
				hide 			: 0,
				hide_from_list	: 0,
				notify_type		: "off",
				after_date		: 0,
				notify_template : '',
				notify_template_email : '',
				action_interval: 300,
			};
		},

		/*
		*	function urlRoot()
		*	Get sync url
		*	@return {string} url
		*/
		urlRoot: function(){
			return AppConfig.host + '/rest/funnel/stages';
		},

		/*
		*	function parse()
		*	Parse server response when sync
		*	@param 	{mixed}	response
		*	@return {json}	result
		*/
		parse: function(response){
			if(response.result !== undefined){
				return response.result.data;
			}else{
				return response;
			}
		},

        validate: function(attrs, options) {
            if (!attrs.name) {
                return 'Не указано имя шага'
            }
        }
	});
});
